import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=d5d6ec9e&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d6ec9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5d6ec9e')) {
      api.createRecord('d5d6ec9e', component.options)
    } else {
      api.reload('d5d6ec9e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=d5d6ec9e&scoped=true&", function () {
      api.rerender('d5d6ec9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rfl328qRSfcz/JS/comp/Accordion.vue"
export default component.exports